import { useCallback, useEffect, useState } from 'react';

const NO_GROUPS: ReadonlySet<string> = new Set<string>();

export function useListPageGroupCollapse({ resetKey }: { resetKey: string }) {
  const [collapsedGroupKeys, setCollapsedGroupKeys] =
    useState<ReadonlySet<string>>(NO_GROUPS);

  useEffect(() => {
    setCollapsedGroupKeys(NO_GROUPS);
  }, [resetKey]);

  const toggleGroup = useCallback((groupKey: string) => {
    setCollapsedGroupKeys((current) => {
      const next = new Set(current);

      if (next.has(groupKey)) {
        next.delete(groupKey);
      } else {
        next.add(groupKey);
      }

      return next;
    });
  }, []);
  const expandAllGroups = useCallback(
    () => setCollapsedGroupKeys(NO_GROUPS),
    [],
  );
  const collapseGroups = useCallback(
    (groupKeys: readonly string[]) => setCollapsedGroupKeys(new Set(groupKeys)),
    [],
  );
  const areAllCollapsed = useCallback(
    (groupKeys: readonly string[]) =>
      groupKeys.length > 0 &&
      groupKeys.every((groupKey) => collapsedGroupKeys.has(groupKey)),
    [collapsedGroupKeys],
  );

  return {
    collapsedGroupKeys,
    toggleGroup,
    expandAllGroups,
    collapseGroups,
    areAllCollapsed,
  };
}
